'use strict';

angular.module('TurneroApp').config([
    '$stateProvider',
    '$urlRouterProvider',
    '$locationProvider',
    'TurneroAppConstant',
    function ($stateProvider, $urlRouterProvider, $locationProvider, TurneroAppConstant) {
        $urlRouterProvider.otherwise('/turnos');
        var head = " | Turnero";
        var title = "Turnos" + head;

        //$locationProvider.html5Mode(false).hashPrefix('#!');

        $stateProvider.state('admin', {
            data: {
                pageTitle: title,
                bodyClass: 'page-boxed page-header-fixed page-sidebar-closed-hide-logo page-container-bg-solid admin-body'
            },
            template: '<co-admin usuario="usuario"></co-admin>'

            //CIUDADANO
        }).state('ciudadano', {
            data: {
                pageTitle: title,
                bodyClass: 'page-boxed page-header-fixed page-container-bg-solid'
            },
            abstract: true,
            url: '/turnos',
            template: '<co-ciudadano usuario="usuario"></co-ciudadano>'
        }).state('ciudadano.home', {
            template: '<co-ciudadanohome></co-ciudadanohome>',
            url: '',
        }).state('ciudadano.misturnos', {
            url: '/misturnos',
            template: '<co-misturnos></co-misturnos>',
            data: { pageTitle: 'Mis Turnos' + head }
        }).state('ciudadano.atenciontelefonica', {
            url: '/telefonico',
            template: '<co-atenciontelefonica></co-atenciontelefonica>',
        }).state('ciudadano.tramitealternativa', {
            url: '/tramitealternativa',
            template: '<co-tramite-alternativa></co-tramite-alternativa>',
            data: {pageTitle: `Seleccionar alternativa ${head}`}
        }).state('ciudadano.tramites', {
            url: '/tramites',
            template: '<co-tramites-online></co-tramites-online>',
            data: { pageTitle: 'Seleccionar trámite' + head }
        }).state('ciudadano.centrosatencion', {
            url: '/centros',
            template: '<co-centroatencion-online></co-centroatencion-online>',
            data: { pageTitle: 'Seleccionar centro de atención' + head }
        }).state('ciudadano.calendario', {
            url: '/calendario',
            template: '<co-calendario></co-calendario>'
        }).state('ciudadano.tasas', {
            url: '/tasasRetributivas',
            template: '<co-tasas-detalles></co-tasas-detalles>',
            data: { pageTitle: `Tasas Retributivas de Servicios ${head}`}
        }).state('ciudadano.tasashistorico', {
            url: '/tasasHistorico',
            template: '<co-tasas-historico></co-tasas-historico>',
            data: { pageTitle: `Tasas Retributivas de Servicios ${head}`}
        }).state('ciudadano.confirmacion', {
            url: '/confirmacionTurno',
            template: '<co-confirmacion-online></co-confirmacion-online>',
            data: { pageTitle: 'Solicitar un turno' + head }
            // ENCUESTA
        }).state('encuesta', {
            url: '/encuesta?:idTurno:idCalificacion:hash',
            component: 'coEncuesta',
            data: {
                pageTitle: 'Calificacion de atencion' + head
            }
        }).state('recepcion', {
            url: '/recepcion',
            component: 'coRecepcion',
            data: {
                pageTitle: 'Recepción' + head
            }

            // CONFIRMACION CANCELAR TURNO 
        }).state('cancelarturno', {
            url: '/cancelarturno/:idTurno',
            component: 'coCancelarTurno',
            data: {
                pageTitle: 'Confirmar cancelación turno' + head
            }

            //  ADMINISTRADOR
        }).state('admin.turnos', {
            url: '/turnos',
            template: '<co-ciudadanohome></co-ciudadanohome>'
        }).state('admin.centrosatencion', {
            url: '/administrar/centros',
            component: 'coCentrosAtencion',
            data: { pageTitle: 'Administrar Centros' + head }
        }).state('admin.tramites', {
            url: '/administrar/tramites',
            component: 'coTramites',
            data: { pageTitle: 'Administrar Trámites' + head }
        }).state('admin.darTurno', {
            url: '/asistencia/calendario',
            component: 'coAsistenciaDarTurno',
            data: {
                pageTitle: 'Asistencia Calendario' + head
            }
        }).state('admin.darTurnoTelefonico', {
            url: '/asistencia/telefonico',
            component: 'coDarTurnoTelefonico',
            data: {
                pageTitle: 'Asistencia Telefonica' + head
            }
        }).state('admin.anunciarTurno', {
            url: '/asistencia/anunciar',
            component: 'coAsistenciaAnunciarTurno',
        }).state('admin.consultaTurnoTelefonico', {
            url: TurneroAppConstant.url.Consulta_Telefonico,
            component: 'coAsistencia',
            data: { pageTitle: 'Asistencia Turnos Telefonicos' + head }
        }).state('admin.consultaTurno', {
            url: '/asistencia/turnos',
            component: 'coAsistencia',
            data: { pageTitle: 'Asistencia Turnos' + head }
        }).state('admin.asistencia', {
            url: '/asistencia',
            redirectTo: 'admin.consultaTurno',
        }).state('admin.grupos', {
            url: '/grupos',
            component: 'coGrupos',
            data: {
                pageTitle: 'Grupos' + head
            }
        }).state('admin.grupousuarios', {
            url: '/grupos/usuarios',
            component: 'coGruposUsuarios',
            data: {
                pageTitle: 'Grupos' + head
            }
        })
       .state('admin.motivos', {
            url: '/administrar/motivos',
            component: 'coMotivos',
            data: { pageTitle: 'Administrar Motivos' + head }
        }).state('admin.puestos', {
            url: '/puestos',
            component: 'coPuestos',
            data: { pageTitle: 'Puestos' + head }
        }).state('admin.usuarios', {
            url: '/usuarios',
            component: 'coUsuarios',
            data: { pageTitle: 'Usuarios' + head }

            //SUPERVISION
        }).state('admin.atencionencurso', {
            url: '/atencionencurso',
            component: 'coAtencionEnCurso',
            data: {
                pageTitle: 'Supervision' + head
            }
        }).state('admin.estadoDelSalon', {
            url: '/estadodelsalon',
            component: 'coEstadoDeSalon',
            data: { pageTitle: 'Supervision' + head }
        }).state('admin.puestosSalon', {
            url: '/puestosSalon',
            component: 'coEstadoPuestosSalon',
            data: { pageTitle: 'Supervision' + head }
        }).state('admin.bloqueoAtencion', {
            url: '/supervision/bloquear',
            component: 'coBloqueoatencion',
            data: {
                pageTitle: 'Supervision' + head
            }
        }).state('admin.confEncuestas', {
            url: '/supervision/encuestas',
            component: 'coEncuestas',
            data: {
                pageTitle: 'Configurar Encuestas' + head
            }

    

        }).state('sidebar', {
            abstract: true,
            url: '/sidebar',
            template: '<co-sidebar-extension></co-sidebar-extension>',
            data: {
                pageTitle: 'Sidebar | e-Turnos'
            }
        })
        .state('sidebar.sidebarAtencionConfig', {
            url: '/atencion/seleccion',
            component: 'coSidebarAtencionSeleccion',
            data: {
                pageTitle: 'Pantalla Atencion Sidebar | e-Turnos'
            }
        }).state('sidebar.sidebarAtencionListado', {
            url: '/atencion/listado',
            component: 'coSidebarAtencion',
            data: { 
                pageTitle: 'Sidebar Atencion | e-Turnos' 
            }
        }).state('reimprimir1', {
            url: '/reimprimir?:Id_Turno&:Desde_Ciudadano',
            component: 'coTurnoreimprimir'
        //Método anterior para mantener compatibilidad (solo si se usa por fuera)
        }).state('reimprimir2', {
            url: '/reimprimir/:Id_Turno',
            component: 'coTurnoreimprimir'

        }).state('certificado',{
            url: '/certificado?:Id_Turno',
            component: 'coCertificado'

        }).state('imprimirODL', {
            url: '/imprimirODL/:Id_Turno',
            component: 'coTurnoOrdendellegadaImprimir'
        }).state('imprimirListado', {
            url: '/imprimirListado/',
            component: 'coTurnoListadoImprimir'
        }).state('admin.agendas', {
            url: '/agendas',
            component: 'coAgendasConsulta',
            data: {
                pageTitle: 'Agendas' + head
            }
        }).state('admin.atencion', {
            url: '/atencion',
            component: 'coAtencion',
            data: {
                pageTitle: 'Atención | e-Turnos'
            }
        }).state('admin.preguntas', {
            url: '/administrar/preguntas',
            component: 'coPreguntas',
            data: {
                pageTitle: 'Administrar Preguntas' + head
            }
        }).state('admin.roles', {
            url: '/roles',
            component: 'coRoles',
            data: { pageTitle: 'Roles' + head }
            //REPORTES
        }).state('admin.reportes', {
            url: '/reportes',
            component: 'coReportes',
            data: {
                pageTitle: 'Reportes' + head
            }
        }).state('admin.encuestas', {
            url: '/encuestas',
            component: 'coReportesEncuestas',
            data: {
                pageTitle: 'Reporte de Encuestas' + head
            }
        }).state('monitor', {
            url: '/monitor',
            component: 'coMonitor',
            data: {
                pageTitle: 'Monitor de actividades' + head
            }
            //LLAMADOR 
        }).state('llamador', {
            url: '/llamador',
            component: 'coLlamador',
            data: { pageTitle: 'Llamador | Turnero' }
            //TURNOS_PORTAL
        }).state('turnosConSesion', {
            url: '/turnos?:sesionid&:sessionId&:sessionid&:idCentroAtencion&:tramitePortal&:modalidad&:idCodigo&:n_ciudadano&:idPersona&:idAgenda&:modoClienteMiDocta',
            component: 'coFrameExterno',
            data: {
                pageTitle: 'Frame Externo' + head
            }
        }).state('turnos', {
            url: '/turnos?:idCentroAtencion&:tramitePortal&:modalidad&:idCodigo&:n_ciudadano&:idPersona&:idAgenda&:modoClienteMiDocta',
            component: 'coFrameExterno',
            data: {
                pageTitle: 'Frame Externo' + head
            }
        }).state('ciudadanoPortal', {
            data: {
                pageTitle: title,
                bodyClass: 'page-boxed page-header-fixed page-container-bg-solid'
            },
            //abstract: true,
            url: '/turnosPortal',
            template: '<co-ciudadano usuario="usuario"></co-ciudadano>'
        }).state('ciudadanoPortal.calendarioPortal', {
            url: '?:tramitePortal&:idCentroAtencion&:idAgenda',
            template: '<co-turno-portal-online usuario="usuario"></co-turno-portal-online>',
            data: { pageTitle: 'Calendario' + head }
        }).state('ciudadanoPortal.tramites', {
            url: '/tramites',
            template: '<co-tramites-online></co-tramites-online>',
            data: { pageTitle: 'Seleccionar trámite' + head }
        }).state('ciudadanoPortal.centrosatencion', {
            url: '/centros',
            template: '<co-centroatencion-online></co-centroatencion-online>',
            data: { pageTitle: 'Seleccionar centro de atención' + head }
        }).state('ciudadanoPortal.calendario', {
            url: '/calendario',
            template: '<co-calendario></co-calendario>'
        }).state('ciudadanoPortal.confirmacion', {
            url: '/confirmacionTurno',
            template: '<co-confirmacion-online></co-confirmacion-online>',
        }).state('login', {
            url: '/login?:sesionid',
            component: 'coLogin',
            data: {
                pageTitle: 'Iniciando Sesión'
            }
        }).state('home', {
            url: '/?:sesionid',
            component: 'coLogin',
            data: {
                pageTitle: 'Iniciando Sesión'
            }
        }).state('integracionMiDocta', {
            url: '/integracion/mi-docta?:sesionid&:sessionId&:sessionid&:destino&:idCentroAtencion&:tramitePortal&:modalidad&:idAgenda&:error',
            component: 'coMiDoctaIframeComponent',
            data: {
                pageTitle: 'Integración Mi Docta | Turnero'
            }
        }).state('integracionMiDoctaIframeComponent', {
            url: '/integracion/mi-docta/iframe?:sesionid&:sessionId&:sessionid&:destino&:idCentroAtencion&:tramitePortal&:modalidad&:idAgenda&:error',
            component: 'coMiDoctaIframeComponent',
            data: {
                pageTitle: 'Integración Mi Docta | Turnero'
            }
        }).state('errores', {
            url: '/errores',
            component: 'coErrores',
            data: {
                pageTitle: 'Errores | Turnero'
            }
        });

        $locationProvider.html5Mode(true);
    }]);



// WEBPACK FOOTER //
// ./app/routes.js